'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: ', ';\n  height: ', ';\n  background-color: ', ';\n  border-radius: 50%;\n'], ['\n  width: ', ';\n  height: ', ';\n  background-color: ', ';\n  border-radius: 50%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  transform: scale(1.2);\n  position: relative;\n  top: 2px;\n'], ['\n  transform: scale(1.2);\n  position: relative;\n  top: 2px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AVATAR_DIMENSION = '25px';

var SimpleBotWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'AutomatedChatMessageBotAvatar__SimpleBotWrapper'
})(_templateObject, AVATAR_DIMENSION, AVATAR_DIMENSION, _colors.KOALA);

var UIIconBot = (0, _styledComponents2.default)(_UIIcon2.default).withConfig({
  displayName: 'AutomatedChatMessageBotAvatar__UIIconBot'
})(_templateObject2);

var AutomatedChatMessageBotAvatar = function AutomatedChatMessageBotAvatar(_ref) {
  var color = _ref.color;
  return _react2.default.createElement(
    SimpleBotWrapper,
    { className: 'display-flex align-center justify-center' },
    _react2.default.createElement(UIIconBot, { color: color, name: 'simpleBot', size: 'small' })
  );
};

AutomatedChatMessageBotAvatar.propTypes = {
  color: _react.PropTypes.string
};

exports.default = AutomatedChatMessageBotAvatar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/AutomatedChatMessageBotAvatar.js
// module id = 529
// module chunks = 2 3